"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _goods = require("@/api/goods/goods");
var _brand = require("@/api/basic/brand");
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'dishForm',
  props: {
    goodsId: {
      type: [Number, String],
      default: null
    },
    type: {
      type: String,
      default: 'edit'
    }
  },
  data: function data() {
    return {
      resPath: "",
      categories: [],
      brandList: [],
      form: {
        id: null,
        brandId: null,
        brandName: '',
        categories: [],
        outerGoodsId: '',
        goodsType: 1,
        goodsName: '',
        goodsNameEn: '',
        goodsBrief: '',
        goodsLabel: '',
        goodsAttrLabel: '',
        goodsSubscript: '',
        goodsThumbnailUrl: '',
        goodsImgUrl: '',
        goodsBannerUrl: '',
        boxPrice: 0
      },
      rules: {
        goodsName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        categories: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change'
        }]
      },
      thumbnailFileList: [],
      coverFileList: [],
      bannerFileList: [],
      previewMediaDialog: {
        visible: false,
        url: '',
        isVideo: false
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var cat, brandRes, res, data, bannerUrls;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _goods.getCategoryTree)();
            case 1:
              cat = _context.sent;
              if (cat && cat.data) this.categories = cat.data;
              // 获取品牌列表
              _context.next = 2;
              return (0, _brand.queryList)({
                current: 1,
                size: 1000
              });
            case 2:
              brandRes = _context.sent;
              this.brandList = brandRes.records;
              if (!(this.type === 'edit' && this.goodsId)) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return (0, _goods.getById)(this.goodsId);
            case 3:
              res = _context.sent;
              if (res && res.data) {
                data = res.data;
                this.form = _objectSpread(_objectSpread(_objectSpread({}, this.form), data), {}, {
                  categories: [data.categoryFirstId, data.categorySecondId].filter(Boolean)
                });
                if (data.goodsThumbnailUrl) {
                  this.thumbnailFileList = [{
                    name: '列表图',
                    url: this.resPath + data.goodsThumbnailUrl
                  }];
                }
                if (data.goodsImgUrl) {
                  this.coverFileList = [{
                    name: '封面图',
                    url: this.resPath + data.goodsImgUrl,
                    isVideo: this.isVideoFile(data.goodsImgUrl)
                  }];
                }
                // 处理轮播图（多图）
                if (data.goodsBannerUrl) {
                  bannerUrls = data.goodsBannerUrl.split(',').filter(function (url) {
                    return url.trim();
                  });
                  this.bannerFileList = bannerUrls.map(function (url, index) {
                    return {
                      name: "\u8F6E\u64AD\u56FE".concat(index + 1),
                      url: _this.resPath + url.trim(),
                      isVideo: _this.isVideoFile(url.trim())
                    };
                  });
                }
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    handleSave: function handleSave() {
      var _this2 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var formData;
          return regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (valid) {
                  _context2.next = 1;
                  break;
                }
                return _context2.abrupt("return");
              case 1:
                // 处理分类数据，确保只传递有效的分类ID
                formData = _objectSpread({}, _this2.form); // 将 categories 转换为 categoryFirstId 和 categorySecondId
                if (formData.categories && formData.categories.length > 0) {
                  formData.categoryFirstId = formData.categories[0];
                  formData.categorySecondId = formData.categories.length >= 2 ? formData.categories[1] : null;
                }

                // 移除前端专用的 categories 字段
                delete formData.categories;
                if (!(_this2.type === 'add')) {
                  _context2.next = 3;
                  break;
                }
                _context2.next = 2;
                return insert(formData);
              case 2:
                _context2.next = 4;
                break;
              case 3:
                _context2.next = 4;
                return (0, _goods.update)(formData);
              case 4:
                _this2.$message.success(_this2.type === 'add' ? '新增成功' : '编辑成功');
                _this2.$emit('saved');
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handlePictureUpload: function () {
      var _handlePictureUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref2, type) {
        var file, formData, res, url;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              file = _ref2.file;
              if (this.validateFile(file, type === 'img')) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              formData = new FormData();
              formData.append('file', file);
              _context3.next = 2;
              return (0, _goods.uploadPhotoAddOrUpd)(formData);
            case 2:
              res = _context3.sent;
              url = res.data;
              if (type === 'thumbnail') {
                this.form.goodsThumbnailUrl = url;
                this.thumbnailFileList = [{
                  name: '列表图',
                  url: this.resPath + url
                }];
              } else {
                this.form.goodsImgUrl = url;
                this.coverFileList = [{
                  name: '封面图',
                  url: this.resPath + url,
                  raw: file,
                  isVideo: this.isVideoFile(url)
                }];
              }
              this.$message.success('上传成功');
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handlePictureUpload(_x2, _x3) {
        return _handlePictureUpload.apply(this, arguments);
      }
      return handlePictureUpload;
    }(),
    handleRemoveFile: function handleRemoveFile(file, fileList, type) {
      if (type === 'thumbnail') {
        this.thumbnailFileList = [];
        this.form.goodsThumbnailUrl = '';
      } else if (type === 'img') {
        this.coverFileList = [];
        this.form.goodsImgUrl = '';
      }
    },
    handleBannerUpload: function () {
      var _handleBannerUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref3) {
        var file, formData, res, url, urls;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              if (this.validateFile(file, true)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              formData = new FormData();
              formData.append('file', file);
              _context4.next = 2;
              return (0, _goods.uploadPhotoAddOrUpd)(formData);
            case 2:
              res = _context4.sent;
              url = res.data; // 将新上传的图片URL添加到列表
              if (!this.form.goodsBannerUrl) {
                this.form.goodsBannerUrl = url;
              } else {
                urls = this.form.goodsBannerUrl.split(',').filter(function (u) {
                  return u.trim();
                });
                urls.push(url);
                this.form.goodsBannerUrl = urls.join(',');
              }
              // 更新文件列表
              this.bannerFileList.push({
                name: file.name,
                url: this.resPath + url,
                isVideo: this.isVideoFile(url)
              });
              this.$message.success('上传成功');
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleBannerUpload(_x4) {
        return _handleBannerUpload.apply(this, arguments);
      }
      return handleBannerUpload;
    }(),
    handleRemoveBannerFile: function handleRemoveBannerFile(file, fileList) {
      // 从 fileList 中找到被删除文件的索引
      var index = this.bannerFileList.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (index > -1) {
        // 从 form.goodsBannerUrl 中删除对应的URL
        var urls = this.form.goodsBannerUrl.split(',').filter(function (u) {
          return u.trim();
        });
        urls.splice(index, 1);
        this.form.goodsBannerUrl = urls.join(',');
      }
      // 更新文件列表
      this.bannerFileList = fileList;
    },
    handlePreview: function handlePreview(file) {
      if (!file) return;
      var url = file.url || file.response && file.response.data || '';
      if (!url) {
        this.$message.warning('无法获取图片/视频预览地址');
        return;
      }
      var isVideo = file.isVideo || this.isVideoFile(url);
      this.previewMediaDialog = {
        visible: true,
        url: url,
        isVideo: !!isVideo
      };
    },
    // 判断是否为视频文件
    isVideoFile: function isVideoFile(url) {
      if (!url) return false;
      var ext = url.split('.').pop().toLowerCase();
      return ['mp4', '3gp', 'm3u8'].includes(ext);
    },
    // 验证上传文件
    validateFile: function validateFile(file) {
      var isCover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isImage = file.type.startsWith('image/');
      var isVideo = file.type.startsWith('video/');
      var ext = file.name.split('.').pop().toLowerCase();
      var isM3u8 = ext === 'm3u8';

      // 封面图支持图片和视频，列表图只支持图片
      if (isCover) {
        if (!isImage && !isVideo && !isM3u8) {
          this.$message.error('只能上传图片或视频文件!');
          return false;
        }
      } else {
        if (!isImage) {
          this.$message.error('只能上传图片文件!');
          return false;
        }
      }

      // 图片大小限制
      if (isImage && file.size / 1024 / 1024 > 2) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }

      // 视频大小限制
      if ((isVideo || isM3u8) && file.size / 1024 / 1024 > 50) {
        this.$message.error('视频大小不能超过 50MB!');
        return false;
      }
      return true;
    }
  }
};